import { useState, useEffect } from "react";
import { Text, Title, Loader, Center, Group, Stack } from "@mantine/core";
import { IconWand } from "@tabler/icons-react";
import ReactTimeago from "react-timeago-i18n";
import { useStore } from "../../store";
import { getThreads } from "./threadApi";
import SelectCard from "../../_Common/SelectedCard";

export default function PlaygroundThreadList() {
  const [threads, setThreads] = useState([]);
  const [isLoadingThreads, setIsLoadingThreads] = useState(true);

  const chatState = useStore((state) => state.chat);
  const setChatState = useStore((state) => state.setChat);
  const selectedThread = useStore((state) => state.chat.selectedThread);
  const threadListTimestamp = useStore((state) => state.threadListTimestamp);

  const setSelectedThread = (q) =>
    setChatState({ ...chatState, selectedThread: q });

  useEffect(() => {
    setIsLoadingThreads(true);
    getThreads().then((data) => {
      setThreads(data);
      setIsLoadingThreads(false);
    });
  }, [threadListTimestamp]);

  if (isLoadingThreads)
    return (
      <Center>
        <Loader />
      </Center>
    );

  return (
    <Stack>
      <SelectCard
        selected={selectedThread == null}
        onClick={() => setSelectedThread(null)}
      >
        <Group justify="space-between">
          <Text fw={500}>New thread</Text>
          <IconWand />
        </Group>
      </SelectCard>
      {threads.map((thread) => (
        <SelectCard
          key={thread.id}
          onClick={() => setSelectedThread(thread)}
          selected={thread.id === selectedThread?.id}
        >
          <Group justify="space-between">
            <Title order={4}>{thread.title}</Title>

            <Text size="sm">
              <ReactTimeago date={thread.created} />
            </Text>
          </Group>

          <Text size="sm" lineClamp={3} c="dimmed">
            {thread.synopsis ?? "No messages yet"}
          </Text>
        </SelectCard>
      ))}
    </Stack>
  );
}
